import React, { useContext, useState } from "react";

import styled from "styled-components";

import ComponentContext from "../../contexts/ComponentContext";
import Loader from "../../shared/components/Loader/Loader";
import breakpoints from "../../shared/constants";

const StyledIFrameWrapper = styled.div`
  flex-grow: 1;

  height: ${({ heights }) =>
    heights.sm ? `${heights.sm} !important` : "55vh"};
  @media (min-width: ${breakpoints.TABLET}) {
    height: ${({ heights }) =>
      heights.md ? `${heights.md} !important` : "95vh"};
  }
  @media (min-width: ${breakpoints.DESKTOP}) {
    height: ${({ heights }) =>
      heights.md ? `${heights.md} !important` : "95vh"};
  }
`;

const StyledIFrame = styled.iframe`
  width: ${({ width }) => width || "100%"};
`;
function Iframe() {
  const { url, heightSM, heightMD, heightLG, width, title } =
    useContext(ComponentContext);

  const [isIframeLoading, setIsIframeLoading] = useState(true);

  return (
    <StyledIFrameWrapper
      className="justify-content-center d-flex"
      heights={{ lg: heightLG, md: heightMD, sm: heightSM }}
    >
      {isIframeLoading && (
        <div className="position-absolute start-0 end-0 bottom-0 top-0 d-flex justify-content-center align-items-center bg-white">
          <Loader />
        </div>
      )}
      <StyledIFrame
        allow="camera; microphone"
        className="h-100"
        onLoad={() => setIsIframeLoading(false)}
        seamless
        src={url}
        title={title || "iframe"}
        width={width}
      />
    </StyledIFrameWrapper>
  );
}

export default Iframe;
